import React from "react";
import { MimaText, Modal } from "../../components";
import styles from "../../assets/styles/InvoiceReceipt/InvoiceReceipt.module.scss";
import { date, amountFormatter } from "../../utils/utils";
import { invoiceStore } from "../../stores";

const ViewMore = ({ closeModal, invoice }) => {
  const { selectedInvoice } = invoiceStore;

  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" align="center" mb={3}>
        Invoice Info
      </MimaText>

      <div className={styles.modal}>
        <div className={styles.modal__beside}>
          <MimaText labelTitle="Invoice number">
            {selectedInvoice.number}
          </MimaText>
          <div
            className={`status ${selectedInvoice.status === "FULLY-PAID" ? "status__green" : selectedInvoice.status === "UNPAID" ? "status__red" : selectedInvoice.status === "VOID" ? "status__grey" : "status__dark__yellow"}`}
          >
            {selectedInvoice.status}
          </div>
        </div>

        <MimaText labelTitle="Date Created">
          {date(selectedInvoice.createdAt)}
        </MimaText>
        <MimaText labelTitle="Customer Name">
          {selectedInvoice?.customer?.fullname}
        </MimaText>
        <MimaText labelTitle="Amount">
          {amountFormatter(selectedInvoice.currencyCode).format(
            selectedInvoice.transactionAmount
          )}
        </MimaText>
        <MimaText labelTitle="Discount">
          {amountFormatter(selectedInvoice.currencyCode).format(
            selectedInvoice.discountAmount
          )}
        </MimaText>
        <MimaText labelTitle="Deposit">
          {amountFormatter(selectedInvoice.currencyCode).format(
            selectedInvoice.deposit
          )}
        </MimaText>
        <MimaText labelTitle="Due Date">
          {date(
            selectedInvoice?.dueDate
              ? selectedInvoice?.dueDate
              : selectedInvoice?.parentInvoice?.dueDate
          )}
        </MimaText>
      </div>
    </Modal>
  );
};
export default ViewMore;
